import Radium from "radium"
import { keyframes } from "higher-order-components/configured-radium/"

import fadeIn from "react-animations/lib/fade-in"
import slideInLeft from "react-animations/lib/slide-in-left"
import slideInUp from "react-animations/lib/slide-in-up"
import bounceInRight from "react-animations/lib/bounce-in-right"
import zoomInDown from "react-animations/lib/zoom-in-down"

export const animate = animation => {
  const myAnimation = {
    animation: "x .5s",
    animationName: Radium.keyframes(fadeIn, "fadeIn")
  }

  if (animation) {
    if (animation.duration) {
      myAnimation.animation = "x " + animation.duration + "ms"
    }

    switch (animation.effect) {
    case "fadeIn":
      myAnimation.animationName = Radium.keyframes(fadeIn, "fadeIn")
      break
    case "slideInLeft":
      myAnimation.animationName = Radium.keyframes(slideInLeft, "slideInLeft")
      break
    case "slideInUp":
      myAnimation.animationName = Radium.keyframes(slideInUp, "slideInUp")
      break
    case "bounceInRight":
      myAnimation.animationName = Radium.keyframes(bounceInRight, "bounceInRight")
      break
    case "zoomInDown":
      myAnimation.animationName = Radium.keyframes(zoomInDown, "zoomInDown")
      break
    case "cut":
      myAnimation.animationName = Radium.keyframes(cutKeyframes, "cut")
      break
    default:
      myAnimation.animationName = Radium.keyframes(fadeIn, "fadeIn")
    }
  }

  return myAnimation
}

const cutKeyframes = keyframes({
  from: {
    opacity: 1
  }
})



// WEBPACK FOOTER //
// ./src/utils/animations.js